import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {DhlOrderForm} from '../models/order-form';

export const dhlValidateAddressActionTypes = {
  VALIDATED: type('[DHL Address Validate] Add'),
  VALIDATED_SUCCESS: type('[DHL Address Validate] Add Success'),
  VALIDATED_FAIL: type('[DHL Address Validate] Add Fail')
};

export class ValidatedAddressDHLAction implements Action {
  readonly type = dhlValidateAddressActionTypes.VALIDATED;
  constructor(public payload?: DhlOrderForm) {
  }
}

export class ValidatedAddressDHLSuccessAction implements Action {
  readonly type = dhlValidateAddressActionTypes.VALIDATED_SUCCESS;
  constructor(public payload?: Object) {}
}

export class ValidatedAddressDHLFailAction implements Action {
  readonly type = dhlValidateAddressActionTypes.VALIDATED_FAIL;
  constructor(public payload?: string) {}
}

